<template>
  <el-dialog
    :append-to-body="true"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :title="$t('seller.process')"
    :visible.sync="handleDialog"
    width="500px"
    @close="handleNewCodeDialog"
  >
    <div style="padding: 0 20px">
      <el-form
        ref="addFormRef"
        :inline="false"
        :model="handleForm"
        :rules="rules"
        class="search-form"
        label-position="top"
      >
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item :label="$t('seller.processingMethod')" prop="handlerMethod">
              <el-select
                v-model="handleForm.handlerMethod"
                :placeholder="$t('GlobalSetObj.all')"
                clearable
                style="width: 100%"
              >
                <el-option key="1" :label="$t('seller.resubmit')" :value="1" />
                <el-option key="2" :label="$t('seller.rejectRegistration')" :value="2" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <!-- 选择提交的信息 -->
            <el-form-item :label="$t('seller.selectSubmittedInfo')" prop="resubmitInfo">
              <el-cascader
                v-model="handleForm.resubmitInfo"
                :options="resubmitInfo"
                :props="props"
                :show-all-levels="false"
                clearable
                collapse-tags
                filterable
                style="width: 100%"
                @change="handlerRsubmitInfoChange"
              />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <!-- 留言 -->
            <el-form-item :label="$t('seller.message')" prop="remarks" style="width: 100%">
              <el-input
                v-model="handleForm.remarks"
                :placeholder="$t('userManage.pleaseInput')"
                :rows="3"
                clearable
                maxlength="300"
                show-word-limit
                type="textarea"
              />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <div style="float: right">
              <!--取消-->
              <el-button
                size="small" @click="handleNewCodeDialog"
              >{{ $t('GlobalSetObj.cancel') }}
              </el-button>
              <!--确定-->
              <el-button
                size="small" type="primary" @click="submitForm"
              >{{ $t('GlobalSetObj.determine') }}
              </el-button>
            </div>
          </el-col>
        </el-row>
      </el-form>
    </div>
  </el-dialog>
</template>

<script>
import { deliveryRegisterAppMenuInfo, deliveryRegisterHandle } from '@/api/newExpressAPI/userModule';

export default {
  props: {
    rowObj: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      handleDialog: false,
      resubmitInfo: [],
      handleForm: {
        id: '',
        handlerMethod: '',
        remarks: '',
        resubmitInfo: []
      },
      rules: {
        handlerMethod: [
          { required: true, message: this.$t('GlobalSetObj.pleaseChoose'), trigger: 'change' }
        ],
        resubmitInfo: [
          { required: true, message: this.$t('GlobalSetObj.pleaseChoose'), trigger: 'blur' }
        ],
        remarks: [{ required: true, message: this.$t('GlobalSetObj.pleaseInput'), trigger: 'blur' }]
      },
      props: {
        multiple: true,
        value: 'fieldName',
        label: 'desc',
        children: 'children'
      },
      selectedObjects: [] // 用于存储选中的对象
    };
  },
  methods: {
    submitForm() {
      this.$refs['addFormRef'].validate((valid) => {
        if (valid) {
          this.selectedObjects = [];
          this.handleForm.resubmitInfo.forEach(([desc, fieldName]) => {
            const menuObj = this.resubmitInfo.find((item) => item.desc === desc);
            if (menuObj) {
              const childObj = menuObj.children.find((child) => child.fieldName === fieldName);
              if (childObj) {
                this.selectedObjects.push(childObj);
              }
            }
          });
          const data = {
            id: this.rowObj.id,
            handlerMethod: this.handleForm.handlerMethod,
            remarks: this.handleForm.remarks,
            resubmitInfo: this.selectedObjects
          };
          deliveryRegisterHandle(data).then((res) => {
            if (res.code === 200) {
              this.$message.success(this.$t('GlobalSetObj.TheOperationSucceeded'));
              this.handleNewCodeDialog();
              this.$emit('invoke-search');
            }
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    // 控制弹框
    async openHandleDialog(row) {
      this.handleForm.resubmitInfo = [];
      const parents = [
        this.$t('seller.identityInfo'),
        this.$t('seller.fileUpload'),
        this.$t('seller.addressInfo'),
        this.$t('seller.bankInfo'),
        this.$t('seller.driverInfo'),
        this.$t('seller.documentInfo'),
        this.$t('seller.vehicleInfo'),
        this.$t('seller.ownerInfo')
      ];
      await this.getMenuInfo();
      this.$nextTick(() => {
        if (row.resubmitInfo) {
          row.resubmitInfo.forEach((item) => {
            const arr = [parents[item.pageNumber - 1], item.fieldName];
            this.handleForm.resubmitInfo.push(arr);
          });
        }
      });
      this.handleForm.handlerMethod = row.handleResult;
      this.handleForm.remarks = row.remarks;
      this.handleForm.id = row.id;
      this.handleDialog = true;
    },
    handlerRsubmitInfoChange(val) {
      console.log(val, 'handlerRsubmitInfoChange');
    },
    handleNewCodeDialog() {
      this.$refs['addFormRef'].resetFields();
      this.handleDialog = false;
    },
    async getMenuInfo(val = '') {
      const data = {
        desc: val
      };
      const res = await deliveryRegisterAppMenuInfo(data);
      if (res.code === 200) {
        const arr = res.data.map((item) => ({
          fieldName: item.appMenu,
          desc: item.appMenu,
          children: item.childrenList.map((child) => ({
            pageNumber: child.pageNumber,
            fieldName: child.fieldName,
            desc: child.desc
          }))
        }));
        console.log(arr, 'arr');
        this.resubmitInfo = arr;
      }
    }
  }
};
</script>

<style scoped></style>
